import { render, staticRenderFns } from "./message-box.vue?vue&type=template&id=4859f4a1&"
import script from "./message-box.vue?vue&type=script&lang=js&"
export * from "./message-box.vue?vue&type=script&lang=js&"
import style0 from "./message-box.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports